<template>
  <div class="doc-save-component" data-grm-comp="Save">
    <div class="doc-save">
      <div class="doc-save-header">
        <p class="doc-save-title">{{ $t("doc.save.download") }}</p>
        <GrmCloseBtn @click="onClose" />
      </div>
      <div class="doc-save-body">
        <p class="doc-save-description">{{ $t("doc.save.select") }}</p>
        <ul class="doc-save-list">
          <li class="doc-save-item">
            <button class="doc-save-button original" @click="onSaveFile({withDrawing: false})">{{ $t("doc.save.original") }}</button>
          </li>
          <li class="doc-save-item">
            <button class="doc-save-button with-drawing" @click="onSaveFile({withDrawing: true})">{{ $t("doc.save.writing") }}</button>
          </li>
        </ul>
        <div v-if="download">{{ $t("doc.save.text") }} : {{downloadPercent}}%</div>
      </div>
    </div>
  </div>
</template>

<script>
import GrmCloseBtn from "@/components/Common/button/GrmCloseBtn";
import {mapActions} from "vuex";

export default {
  name: 'DocSave',
  components: {
    GrmCloseBtn
  },
  data() {
      return {
          download: false,
          downloadPercent: 0
      }
  },
  methods: {
    ...mapActions('doc', [
        'createRoomDocPdf'
    ]),
    onClose() {
      this.$modal('DocSave')
    },
    async onSaveFile({withDrawing=false}) {
      if(this.download){
          // TODO 다운로드 중
          console.log('file downloading');
          return;
      }

      const {roomDocFile} = this.$parent;
      console.log(roomDocFile);

      this.download = true;
      this.downloadPercent = 0;
      try{
        await this.createRoomDocPdf({
            ...roomDocFile,
            options: { withDrawing },
            listener: {
                onprogress: (percent) => {
                    console.log('save original progress :', percent);
                    this.downloadPercent = percent;
                    if(percent >= 100){
                        setTimeout(() => {
                          this.download = false;
                        }, 100);
                    }
                }
            }
        });
      }catch(e){
        console.error(e);
        this.download = false;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.doc-save-component {
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  inset: 0 0 0 60px;
  z-index: 1;
}
.doc-save {
  width: 440px;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 10px 30px rgb(0, 0, 0, 0.3);
  padding: 24px;
}
.doc-save-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.doc-save-title {
  font-size: 14px;
  font-weight: 700;
}
.doc-save-body {
  margin-top: 24px;
}
.doc-save-description {
  font-size: 13px;
}
.doc-save-list {
  margin-top: 18px;
  display: flex;
  gap: 0 14px;
}
.doc-save-item {
  flex: 1;
}
.doc-save-button {
  width: 100%;
  height: 100%;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  padding: 20px;
  background-color: rgba(0, 0, 0, 0.02);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.06);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 10px 0;
  word-break: keep-all;
  transition: 0.1s ease-out;
  &::before {
    content: '';
    width: 60px;
    height: 40px;
    display: block;
  }
  &.original {
    &::before {
      background: url('~@/assets/images/doc_down.svg') no-repeat center / 100% auto;
    }
  }
  &.with-drawing {
    &::before {
      background: url('~@/assets/images/doc_down_drawing.svg') no-repeat center / 100% auto;
    }
  }
  &:hover {
    border-color: #59f;
    background-color: #59f;
    box-shadow: 0 10px 20px rgb(0, 0, 0, 0.2);
    font-weight: 700;
    color: #fff;
  }
}

[grm-device-mobile] {
  .doc-save-component {
    inset: 0;
    z-index: 4;
  }
  .doc-save {
    width: 100%;
    border-radius: 0;
    position: absolute;
    inset: auto 0 0 0 ;
  }
}
</style>